
const ProjectColor = [
    {
        id: 1,
        color: "#FF6600",
    },
    {
        id: 2,
        color: "#0066FF",
    },
    {
        id: 3,
        color: "#22FF00",
    },
    {
        id: 4,
        color: "#AB00FF",
    },
    {
        id: 5,
        color: "#FF1A00",
    },
];
export default ProjectColor;